// SocialHiveHeader.jsx
import React from "react";
import "./SocialHiveHeader.css";
import { useLanguage } from "../../../../LanguageProvider";

const SocialHiveHeader = ({
  activeView,
  setActiveView,
  activeRoom = null,
  annCount,
  activeChannel
}) => {
  const { getTranslation } = useLanguage();

  const tabs = [
    { key: "events", label: getTranslation("events") },
    {
      key: "announcements",
      label: getTranslation("announcements"),
      badge: annCount,
    },
    { key: "documents", label: getTranslation("documents") },
    { key: "gallery", label: getTranslation("gallery") },
  ];

  return (
    <div className="social-hive-header">
      <nav className="social-hive-header__nav">
        {(activeChannel.channelID !== "0" && activeChannel.channelID !== "discover") ? (
          <div className="social-hive-header__nav-list" >
            {tabs.map((tab, index) => (
              <div
                key={tab.key}
                className={`social-hive-header__nav-item${activeView === tab.key ? " active" : ""
                  }`}
                onClick={() => setActiveView(tab.key)}
              >
                {tab.label}
                {/* {tab.badge && (
                  <span className="social-hive-header__badge">{tab.badge}</span>
                )} */}
              </div>
            ))}
          </div>
        ) : (
          <div className="social-hive-header__nav-list" style={{ paddingLeft: "20px" }}>
            <div
              className="social-hive-header__nav-item"
              style={{ cursor: "var(--cursor)", filter: "none" }}
            >
              {activeRoom && (activeRoom.titleDetails?.name + " " + activeRoom.titleDetails?.lastname)}
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};
export default SocialHiveHeader;
